// O gráfico do mês de cada meta de bonificação (Adnéia, 30/10/2026): a conta, sem tela. Os pontos
// vêm prontos da rota /api/dashboard/v2/metas-historico (routes/metas_historico.py); aqui só se
// separa a linha de cada sub-indicador e se escreve o resumo. Sem dado, "?".

export const ROTULO_ORIGEM = {
  foto: 'foto do dia',
  remontado: 'remontado pelo que o ELO guarda',
  aproximado: 'remontado, aproximado',
};

export const diaMes = (s) => (s ? `${s.slice(8, 10)}/${s.slice(5, 7)}` : '?');

export function pontosDaLinha(pontos, rotulo) {
  return (pontos || []).map((p) => {
    const v = p.valores ? p.valores[rotulo] : null;
    return {
      data: p.data,
      dia: diaMes(p.data),
      valor: v === undefined ? null : v,
      fora: !!(p.fora && p.fora[rotulo]),
      origem: p.origem || null,
      ok: p.ok === undefined ? null : p.ok,
      porque: p.porque || '',
    };
  });
}

export function diasSemDado(pontos) {
  return (pontos || []).filter((p) => p.ok === null || p.ok === undefined).map((p) => diaMes(p.data));
}

const plural = (n, um, varios) => `${n} ${n === 1 ? um : varios}`;

export function textoResumo(resumo) {
  if (!resumo) return '';
  return [
    plural(resumo.batidos || 0, 'dia batido', 'dias batidos'),
    plural(resumo.fora || 0, 'fora da meta', 'fora da meta'),
    plural(resumo.sem_dado || 0, 'sem dado', 'sem dado'),
  ].join(' · ');
}

export function formatarValor(v, unidade) {
  if (v === null || v === undefined) return '?';
  const n = Number(v).toLocaleString('pt-BR', { maximumFractionDigits: 2 });
  if (unidade === '%') return `${n}%`;
  return `${n} ${unidade}`;
}
